/**
 * Browser-safe query string builder (replaces Node's querystring).
 * Only flat string/number/boolean values are supported — matching prior usage.
 */
export function stringify (params) {
  const search = new URLSearchParams()
  Object.keys(params || {}).forEach((key) => {
    const value = params[key]
    if (value === undefined || value === null) return
    search.append(key, String(value))
  })
  return search.toString()
}
